import { render, staticRenderFns } from "./EventoSelect.vue?vue&type=template&id=6dd19da0"
import script from "./EventoSelect.vue?vue&type=script&lang=js"
export * from "./EventoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports